import React from 'react'
import infoIconUrl from './assets/community-settings-icon.svg'

function CommunitySettingsIcon({className}: {className?: string}) {
  return <img alt="" aria-hidden className={className} src={infoIconUrl} />
}

export default CommunitySettingsIcon
